// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".precise-price-app .tab-selector--39O3h{font-size:16px;display:flex;border-radius:10px;background-color:#ddd;position:relative}.precise-price-app .tab-selector__tab--1VuYp{flex:0% 1 0;padding:8px 20px;color:var(--primary-color);cursor:pointer;border-radius:10px;display:flex;align-items:center;justify-content:center;text-align:center}.precise-price-app .tab-selector__tab_active--3JGFZ{color:#fff;background-color:var(--primary-color);transition:all .6s ease;cursor:auto}", ""]);
// Exports
exports.locals = {
	"tabSelector": "tab-selector--39O3h",
	"tabSelectorTab": "tab-selector__tab--1VuYp",
	"tabSelectorTabActive": "tab-selector__tab_active--3JGFZ"
};
module.exports = exports;
